import { soFetch } from 'so-fetch';
import checkStatus from '../../utils/checkStatus';
import * as constants from './settings-constants';

export function updateSettingsProps(payload) {
  return { type: constants.UPDATE_SETTINGS_PROP, payload };
}

export function resetPassword(oldPassword, newPassword) {
  return soFetch('/proxy/settings/reset', {
    method: 'put',
    body: { oldPassword, newPassword },
    actionType: constants.RESET_PASSWORD,
  });
}

export function passwordInputModified(passType, newValue) {
  return {
    type: constants.PASSWORD_INPUT_MODIFIED,
    payload: {
      [passType]: newValue,
    },
  };
}
export function passwordResetError(errorMessage, errorFields) {
  return {
    type: constants.RESET_PASSWORD,
    payload: {
      error: true,
      errorFields,
      errorMessage,
    },
  };
}

export function toggleConnectionNotifications(newNotifValue) {
  return soFetch('/proxy/settings/connectionNotifications', {
    method: 'put',
    body: { newNotifValue },
    actionType: constants.TOGGLE_CONNECTION_NOTIFICATIONS,
  });
}

export function hydrateFromServer() {
  return soFetch('/proxy/settings/hydrate', {
    method: 'get',
    actionType: constants.HYDRATE_FROM_SERVER,
  });
}

export function addTempUser() {
  return {
    type: constants.ADD_TEMP_USER,
  };
}

export function deleteTempUser(key) {
  return {
    type: constants.DELETE_TEMP_USER,
    payload: key,
  };
}

export function tempUserPropModified(key, propName, newValue) {
  return {
    type: constants.TEMP_USER_PROP_MODIFIED,
    payload: { key, propName, newValue },
  };
}

export function addNewUsers(clickedButton, newUsersOrderedMap) {
  if (clickedButton === 'add') {
    const newUsersArray = newUsersOrderedMap.valueSeq().map(value => value).toJS();
    return dispatch => {
      dispatch({ type: constants.START_ADDING_NEW_USER });
      return fetch('/proxy/settings/addUsers', {
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html', 'Content-Type': 'application/json' },
        method: 'post',
        body: JSON.stringify({ newUsersArray }),
      })
        .then(checkStatus)
        .then(res => res.json())
        .then((res) => dispatch({ type: constants.ADD_NEW_USERS, payload: res }));
    };
  }

  return {
    type: constants.CLEAR_TEMP_USERS,
  };
}

export function clearAddUserMessage() {
  return {
    type: constants.CLEAR_ADD_USER_MESSAGE,
  };
}
export function clearEditUserMessage() {
  return {
    type: constants.CLEAR_EDIT_USER_MESSAGE,
  };
}

export function disableUser(user) {
  return soFetch('/proxy/settings/disableUser', {
    method: 'put',
    body: { user },
    actionType: constants.USER_DISABLED,
  });
}

export function updateUserBeingEdited(user) {
  return {
    type: constants.EDIT_USER_UPDATED,
    payload: user,
  };
}

export function editUserPropModified(propName, newValue) {
  return {
    type: constants.EDIT_USER_PROP_MODIFIED,
    payload: {
      [propName]: newValue,
    },
  };
}

export function saveUserBeingEdited(user) {
  return soFetch('/proxy/settings/saveEditedUser', {
    method: 'put',
    body: { user },
    actionType: constants.EDIT_USER_SAVED,
  });
}

export function confirmedDisassociateSecondaryEmail(id) {
  return soFetch('/proxy/secondary-email/confirmed-disassociate-secondary-email', {
    method: 'put',
    body: { id, type: 'settings' },
    actionType: constants.CONFIRMED_DISASSOCIATE_SECONDARY_EMAIL,
  });
}

export function addSecondaryEmail(email) {
  return soFetch('/proxy/secondary-email/add-secondary-email', {
    method: 'post',
    body: { email },
    actionType: constants.ADD_SECONDARY_EMAIL,
  });
}

export function resendSecondaryEmailConfirmationLink(email) {
  return soFetch('/proxy/secondary-email/send-secondary-email-confirmation', {
    method: 'put',
    body: { email, type: 'settings' },
    actionType: constants.RESEND_CONFIRMATION_SECONDARY_EMAIL,
  });
}

export function resendConfirmationLink(email) {
  return soFetch('/proxy/settings/resendConfirmationLink', {
    method: 'put',
    body: { email },
    actionType: constants.RESEND_CONFIRMATION_LINK_USER_SETTINGS,
  });
}

export function clearManageUsersMessage() {
  return { type: constants.CLEAR_MANAGE_USERS_MESSAGE };
}



// WEBPACK FOOTER //
// ./src/app/stores/settings/settings-actions.js